import React, { useState } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import useAuth from '../../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import { CommonButton } from '../../../../Styles/CommonStyles';
import { useGetUsersQuery, useHandoverOffTranAssetsMutation, useModifyArrayUserMutation } from '../../../../features/users/usersApiSlice';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useUpdateassetReqMutation, useUpdateBoPartialAssetMutation, useUpdateStorePartialAssetMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import nameStringFn from '../../../../data/nameStringFn';
import UnivReqSelector from './UnivReqSelector';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import { useAddNewTransactionMutation } from '../../../../features/transactions/transactionsApiSlice';
import { useUpdateAssetintransitMutation, useUpdateMultipleDocsMutation } from '../../../../features/addassets/addassetfinalApiSlice';

const Button = styled(CommonButton)`
  padding: 8px 16px;
  min-width: 120px;
  margin-right: 10px;
`;

const ActionButton = styled(Button)`
  background-color: #1976d2;
`;

const AcceptPartialButton = styled(Button)`
  background-color: #4caf50;
  font-weight: 500;
`;

const RejectButton = styled(Button)`
  background-color: #f44336;
`;

const ModifyButton = styled(Button)`
  background-color: #ff9800;
`;

const RemarkContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxHeight: '80vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  overflow: 'auto'
};

const ModalTitle = styled.h2`
  margin-bottom: 20px;
  color: #1976d2;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
`;

// Add styled components for the assets table
const SelectedAssetsContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const SelectedAssetsTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const SelectedAssetsTitle = styled.h3`
  margin-bottom: 0;
  color: #1976d2;
`;

const StyledTableContainer = styled(TableContainer)`
  margin-bottom: 20px;
`;

const StyledTableHead = styled(TableHead)`
  background-color: #1976d2;
  
  & th {
    color: white;
    font-weight: bold;
  }
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const SummaryContainer = styled.div`
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
`;

const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

const SummaryItemName = styled.span`
  font-weight: 500;
  margin-right: 10px;
`;

const SummaryItemCount = styled.span`
  background-color: #1976d2;
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.8rem;
`;

const UserInboxForm = ({ row, handleBack, selectedOptions }) => {
  const [remark, setRemark] = useState('');
  const [openModifyModal, setOpenModifyModal] = useState(false);
  const [modifiedAssets, setModifiedAssets] = useState([{ catName: "", assetName: "", quantity: "" }]);
  const [storeSelectedValue, setStoreSelectedValue] = useState(row?.req_store || '');

  const auth = useAuth();
  let user_current_office = (useSelector((state) => state.office.off));

  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  });

  const { officedata } = useGetofficesQuery('offices', {
    selectFromResult: ({ data }) => ({
      officedata: data?.entities
    }),
  });

  const { storeoffices } = useGetStoreOfficesQuery('storeoffices', {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  });


  const BO_id = officedata ? Object.values(officedata)?.find(office => office?.name === user_current_office)?.Bo : "";
  const storelevel1_id = storeoffices ? Object.values(storeoffices)?.find(office => office?.storeoffice === row?.req_store)?.roleUsers?.L1ReqApprover_A : "";

  const [updateReq] = useUpdateassetReqMutation();
  const [updateBoPartialAsset] = useUpdateBoPartialAssetMutation();
  const [updateStorePartialAsset] = useUpdateStorePartialAssetMutation();
  const [updateBoAssets] = useHandoverOffTranAssetsMutation();
  const [updateAssetinTran] = useUpdateAssetintransitMutation();
  const [addTrans] = useAddNewTransactionMutation();
  const [modifyArrayUser] = useModifyArrayUserMutation();
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();
  

  // Check if this is a partial assets request for forwarding to store
  const isPartialAssetsForStore = row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'uhreq_paraprvd_forstore';
  
  // Check if this is a partial assets request for closing
  const isPartialAssetsForClose = row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'uhreq_paraprvd_forclose';
  
  // Check if this is a request for accepting all assets issued at BO level
  const isAllAssetsBoLevel = row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'uhreq_allbolvlaprvd_forclose';
  
  // Check if this is a request for resubmit after modification
  const isModificationRequest = row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'boreq_back_user_mod';

  // Check if this is a store level 2 approved request ready for user acceptance
  const isStoreLevel2Approved = row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'lvl2req_apprvd_foraccptnce';

  // Handler for asset field changes
  const handleAssetChange = (event, index, newValue, name) => {
    let tempField = [...modifiedAssets];
    if (event?.target?.name) {
      tempField[index][event.target.name] = event.target.value;
      setModifiedAssets(tempField);
    } else {
      tempField[index][name] = newValue === "" ? null : newValue;
      setModifiedAssets(tempField);
    }
  };

  // Handle the modify selection button
  const handleModifySelection = () => {
    // Only initialize from original request if modifiedAssets is empty 
    // (i.e., first time editing)
    if (modifiedAssets.length === 1 && !modifiedAssets[0].catName && !modifiedAssets[0].assetName) {
      if (row?.assets_requested && row.assets_requested.length > 0) {
        const latestRequestedAssets = row.assets_requested[row.assets_requested.length - 1].data;
        setModifiedAssets(latestRequestedAssets.map(asset => ({ ...asset })));
      }
    }
    // Otherwise, keep current modified assets
    setOpenModifyModal(true);
  };

  // Handle closing the modify selection modal
  const handleCloseModifyModal = () => {
    setOpenModifyModal(false);
  };

  // Handle confirming the modified asset selection
  const handleConfirmModification = () => {
    // Validate that all fields are filled
    const allFieldsFilled = modifiedAssets.every(asset =>
      asset.catName && asset.assetName && asset.quantity
    );

    if (!allFieldsFilled) {
      alert("Please fill all asset details before confirming.");
      return;
    }

    setOpenModifyModal(false);
  };

  // Handle resubmitting request to BO after modification
  const handleResubmitToBo = async () => {
    // Check if the modified assets are the same as the original requested assets
    let areAssetsUnchanged = false;
    if (row?.assets_requested && row.assets_requested.length > 0) {
      const originalAssets = row.assets_requested[row.assets_requested.length - 1].data;
      
      // Only consider unchanged if same number of assets and each asset matches exactly
      if (originalAssets.length === modifiedAssets.length) {
        areAssetsUnchanged = true;
        // Deep comparison of each asset
        for (let i = 0; i < originalAssets.length; i++) {
          const original = originalAssets[i];
          const modified = modifiedAssets[i];
          
          if (original.catName !== modified.catName || 
              original.assetName !== modified.assetName || 
              original.quantity !== modified.quantity) {
            areAssetsUnchanged = false;
            break;
          }
        }
      }
    }

    let senttoData = {
      sent_to_tag: "ureq_resubmit_modified",
      Text: remark,
      action: "Request Resubmitted by User After Modification",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: BO_id, name: getSingleuser?.[BO_id]?.name, office: user_current_office, designation: getSingleuser?.[BO_id].designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[BO_id])}-${user_current_office}-${getSingleuser?.[BO_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date()
    };
    
    // Only add assets_requested if the assets were actually changed
    if (!areAssetsUnchanged) {
      senttoData.assets_requested = { 
        time_stamp: new Date(), 
        actionNo: (row?.req_data?.length + 1), 
        data: modifiedAssets 
      };
    }
    
    const body = { id: row?._id, senttoData: senttoData };
    const res = await updateReq(body);
    
    alert(areAssetsUnchanged 
      ? "Request resubmitted to BO without asset changes." 
      : "Request resubmitted to BO with modified assets.");
    
    setModifiedAssets([{ catName: "", assetName: "", quantity: "" }]);
    handleBack();
  };

  // Handle accepting partial assets and forwarding to store
  const handleAcceptPartialForward = async () => {
    const transacData = {
      transac_id: row?.uniqueReqId,
      req_id: "",
      asset_id: row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || [],
      transac_type: row.req_type === "Issue" ? 'boPartialAssetIssue': "boPartialAssetIssue_Ind",
      indi_asset: false,
      from_userid: getSingleuser?.[BO_id]?.email,
      from_office: user_current_office,
      from_desig: getSingleuser?.[BO_id]?.designation?.[user_current_office],
      from_store: row?.req_store,
      to_userid: auth?.email,
      to_office: user_current_office,
      to_desig: auth?.designation?.[user_current_office],
      to_store: row?.req_store,
      pdfPath: "",
      time_stamp: new Date().toISOString()
    };

    let senttoData = {
      sent_to_tag: "ureq_paraccept_fwdstore",
      Text: remark,
      action: "Partial Assets Accepted by User and Forwarded to Store",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: storelevel1_id, name: getSingleuser?.[storelevel1_id]?.name, office: row?.req_store, designation: getSingleuser?.[storelevel1_id]?.designation?.[row?.req_store] }, 
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[storelevel1_id])}-${row?.req_store}-${getSingleuser?.[storelevel1_id]?.designation?.[row?.req_store] || 'Unknown'}`,
      time_stamp: new Date()
    };

    const assetBody = {
      "assetIdArray": row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || [],
      "updates": {
        "in_transit": false,
        "cur_loc": "user",
        "last_trans_date": new Date().toISOString(),
        "alloc_ofc": user_current_office,
        "alloc_user": auth?.id,
        "cur_user_name": `${getSingleuser?.[auth?.id]?.email} (${nameStringFn(getSingleuser?.[auth?.id])})`
      }
    }    
    
    const body = { id: row?._id, senttoData: senttoData };
    const accept_time = new Date().toISOString();
    const status = "accepted";
    const partialbobody = { id: row?._id, accept_time: accept_time, status: status };

    try {
      const res = await updateReq(body);
      const res2 = await updateBoPartialAsset(partialbobody);
      const res3 = await updateMultipleAssetDocs(assetBody);
      const res4 = await addTrans(transacData);
      alert("Partial assets accepted and request forwarded to store.");
      handleBack();
    } catch (error) {
      console.error("Error accepting assets:", error);
      alert("There was an error accepting the assets. Please try again.");
    }
  };

  // Handle accepting partial assets and closing the request
  const handleAcceptPartialAndClose = async () => {

    const transacData = {
      transac_id: row?.uniqueReqId,
      req_id: "",
      asset_id: row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || [],
      transac_type: 'boPartialAssetIssue',
      indi_asset: false,
      from_userid: getSingleuser?.[BO_id]?.email,
      from_office: user_current_office,
      from_desig: getSingleuser?.[BO_id]?.designation?.[user_current_office],
      from_store: row?.req_store,
      to_userid: auth?.email,
      to_office: user_current_office,
      to_desig: auth?.designation?.[user_current_office],
      to_store: row?.req_store,
      pdfPath: "",
      time_stamp: new Date().toISOString()
    };

    let senttoData = {
      sent_to_tag: "ureq_paraccept_close",
      Text: remark,
      action: "Partial Assets Accepted by User. Request Closed.",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[auth?.id])}-${user_current_office}-${auth?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Closed"
    };

    const assetBody = {
      "assetIdArray": row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || [],
      "updates": {
        "in_transit": false,
        "cur_loc": "user",
        "last_trans_date": new Date().toISOString(),
        "alloc_ofc": user_current_office,
        "alloc_user": auth?.id,
        "cur_user_name": `${getSingleuser?.[auth?.id]?.email} (${nameStringFn(getSingleuser?.[auth?.id])})`
      }
    }    
    
    const body = { id: row?._id, senttoData: senttoData };
    const accept_time = new Date().toISOString();
    const status = "accepted";
    const partialbobody = { id: row?._id, accept_time: accept_time, status: status };

    try {
      const res = await updateReq(body);
      const res2 = await updateBoPartialAsset(partialbobody);
      const res4 = await updateMultipleAssetDocs(assetBody);
      const res5 = await addTrans(transacData);
      alert("Partial assets accepted and request closed successfully.");
      handleBack();
    } catch (error) {
      console.error("Error accepting assets:", error);
      alert("There was an error accepting the assets. Please try again.");
    }
  };

  // Handle accepting all assets issued by BO and closing the request
  const handleAcceptAllAssetsAndClose = async () => {
    const transacData = {
      transac_id: row?.uniqueReqId,
      req_id: "",
      asset_id: row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || [],
      transac_type: 'boAllAssetIssue',
      indi_asset: false,
      from_userid: BO_id,
      from_office: user_current_office,
      from_desig: getSingleuser?.[BO_id]?.designation?.[user_current_office],
      from_store: row?.req_store,
      to_userid: auth?.id,
      to_office: user_current_office,
      to_desig: auth?.designation?.[user_current_office],
      to_store: row?.req_store,
      pdfPath: "",
      time_stamp: new Date().toISOString()
    };

    let senttoData = {
      sent_to_tag: "ureq_allasstbolvl_close",
      Text: remark,
      action: "All Assets Accepted by User from BO. Request Closed.",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[auth?.id])}-${user_current_office}-${auth?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Closed"
    };

    const assetBody = {
      "assetIdArray": row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || [],
      "updates": {
        "in_transit": false,
        "cur_loc": "user",
        "last_trans_date": new Date().toISOString(),
        "alloc_ofc": user_current_office,
        "alloc_user": auth?.id,
        "cur_user_name": `${getSingleuser?.[auth?.id]?.email} (${nameStringFn(getSingleuser?.[auth?.id])})`
      }
    }
    
    const body = { id: row?._id, senttoData: senttoData };
    const accept_time = new Date().toISOString();
    const status = "accepted";
    const partialbobody = { id: row?._id, accept_time: accept_time, status: status };

    try {
      const res = await updateReq(body);
      const res2 = await updateBoPartialAsset(partialbobody);
      const res3 = await updateMultipleAssetDocs(assetBody);
      const res4 = await addTrans(transacData);

      alert("All assets accepted and request closed successfully.");
      handleBack();
    } catch (error) {
      console.error("Error accepting assets:", error);
      alert("There was an error accepting the assets. Please try again.");
    }
  };

  // Handle accepting store assets after store level 2 approval
  const handleAcceptStoreAssets = async () => {
    // Create data required for transaction
    const transacData = {
      transac_id: row?.uniqueReqId,
      req_id: "",
      asset_id: row?.store_assets_issue?.[row.store_assets_issue.length - 1]?.assets || [],
      transac_type: 'storeAllAssetIssue',
      indi_asset: false,
      from_userid: Object.values(storeoffices)?.find(office => office?.storeoffice === row?.req_store)?.roleUsers?.L1ReqApprover_A,
      from_office: row?.req_store,
      from_desig: getSingleuser?.[storelevel1_id]?.designation?.[row?.req_store] || "StoreManager",
      from_store: row?.req_store,
      to_userid: auth?.id,
      to_office: user_current_office,
      to_desig: auth?.designation?.[user_current_office],
      to_store: row?.req_store,
      pdfPath: "",
      time_stamp: new Date().toISOString()
    };

    let senttoData = {
      sent_to_tag: "ureq_storeassetsaccpt_close",
      Text: remark || "",
      action: "Store Assets Accepted by User. Request Closed.",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[auth?.id])}-${user_current_office}-${auth?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date().toISOString(),
      curr_status: "Closed"
    };

    const assetBody = {
      "assetIdArray": row?.store_assets_issue?.[row.store_assets_issue.length - 1]?.assets || [],
      "updates": {
        "in_transit": false,
        "cur_loc": "user",
        "last_trans_date": new Date().toISOString(),
        "alloc_ofc": user_current_office,
        "alloc_user": auth?.id,
        "cur_user_name": `${getSingleuser?.[auth?.id]?.email} (${nameStringFn(getSingleuser?.[auth?.id])})`
      }
    }

    const body = { id: row?._id, senttoData: senttoData };
    const accept_time = new Date().toISOString();
    const status = "accepted";
    const storepartialassetbody = { id: row?._id, accept_time, status };

    try {
      
      // Update request status
      const res = await updateReq(body);      
      // Update store partial asset status
      const res2 = await updateStorePartialAsset(storepartialassetbody);
      // Record the transaction
      const res3 =  await addTrans(transacData);
      const res4= await updateMultipleAssetDocs(assetBody);
      
      alert("Store assets accepted and request closed successfully.");
      handleBack();
    } catch (error) {
      console.error("Error accepting store assets:", error);
      alert("There was an error accepting the assets. Please try again.");
    }
  };

  // Handle rejecting assets
  const handleRejectAssets = async () => {
    if (!remark.trim()) {
      alert("Please provide a reason for rejecting the assets.");
      return;
    }

    let senttoData = {
      sent_to_tag: "ureq_assets_rejected",
      Text: remark,
      action: "Request Terminated by User. Request Closed.",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[auth?.id])}-${user_current_office}-${auth?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Terminated"
    };

    const assetBody = {
      assetIdArray: [
        ...(row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || []),
        ...(row?.store_assets_issue?.[row.store_assets_issue.length - 1]?.assets || [])
      ],
      updates: {
        in_transit: false,
      }
    };
    
    const body = { id: row?._id, senttoData: senttoData };

    try {
      const res = await updateReq(body);
      const res2 = await updateMultipleAssetDocs(assetBody);

      alert("Assets rejected and request closed.");
      handleBack();
    } catch (error) {
      console.error("Error rejecting assets:", error);
      alert("There was an error rejecting the assets. Please try again.");
    }
  };

  // Generate summary data from modified assets
  const generateSummary = (assets) => {
    if (!assets || assets.length === 0) return [];

    const summary = assets.reduce((acc, asset) => {
      if (!asset.assetName || !asset.quantity) return acc;
      
      const key = asset.assetName;
      if (!acc[key]) {
        acc[key] = 0;
      }
      acc[key] += parseInt(asset.quantity, 10);
      return acc;
    }, {});

    return Object.entries(summary).map(([name, count]) => ({ name, count }));
  };

  return (
    <>
      <RemarkContainer>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Add Remark"
          variant="outlined"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </RemarkContainer>

      {/* Display modified assets in a table if available */}
      {isModificationRequest && modifiedAssets?.some(asset => asset.catName && asset.assetName && asset.quantity) && (
        <SelectedAssetsContainer>
          <SelectedAssetsTitleContainer>
            <SelectedAssetsTitle>Modified Asset Request</SelectedAssetsTitle>
            <ActionButtonsContainer>
              <Tooltip title="Edit selections">
                <IconButton color="primary" onClick={handleModifySelection}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
            </ActionButtonsContainer>
          </SelectedAssetsTitleContainer>

          {/* Summary section */}
          <SummaryContainer>
            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>
              Total: {modifiedAssets.filter(asset => asset.catName && asset.assetName && asset.quantity).length} items
            </span>
            {generateSummary(modifiedAssets).map((item, index) => (
              <SummaryItem key={index}>
                <SummaryItemName>{item.name}</SummaryItemName>
                <SummaryItemCount>{item.count}</SummaryItemCount>
              </SummaryItem>
            ))}
          </SummaryContainer>

          <StyledTableContainer component={Paper}>
            <Table>
              <StyledTableHead>
                <TableRow>
                  <TableCell>Sl.No.</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Asset Name</TableCell>
                  <TableCell>Quantity</TableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {modifiedAssets.filter(asset => asset.catName && asset.assetName && asset.quantity).map((asset, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{asset.catName}</TableCell>
                    <TableCell>{asset.assetName}</TableCell>
                    <TableCell>{asset.quantity}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </SelectedAssetsContainer>
      )}

      <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
        {isModificationRequest ? (
          modifiedAssets?.some(asset => asset.catName && asset.assetName && asset.quantity) ? (
            <ActionButton onClick={handleResubmitToBo}>
              Resubmit to BO
            </ActionButton>
          ) : (
            <ModifyButton onClick={handleModifySelection}>
              Modify Request
            </ModifyButton>
          )
        ) : isPartialAssetsForStore ? (
          <AcceptPartialButton onClick={handleAcceptPartialForward}>
            Accept Partial Assets & Forward to Store
          </AcceptPartialButton>
        ) : isPartialAssetsForClose ? (
          <AcceptPartialButton onClick={handleAcceptPartialAndClose}>
            Accept Partial Assets & Close Request
          </AcceptPartialButton>
        ) : isAllAssetsBoLevel ? (
          <>
            <AcceptPartialButton onClick={handleAcceptAllAssetsAndClose}>
              Accept Assets & Close Request
            </AcceptPartialButton>
            <RejectButton onClick={handleRejectAssets}>
              Reject/Terminate Request
            </RejectButton>
          </>
        ) : isStoreLevel2Approved ? (
          <AcceptPartialButton onClick={handleAcceptStoreAssets}>
            Accept Store Assets & Close Request
          </AcceptPartialButton>
        ) : null}
      </div>

      {/* Modify Asset Selection Modal */}
      <Modal
        open={openModifyModal}
        onClose={handleCloseModifyModal}
        aria-labelledby="modify-asset-selection-modal"
      >
        <Box sx={ModalStyle}>
          <ModalTitle>Modify Asset Selection</ModalTitle>

          <UnivReqSelector
            field={modifiedAssets}
            setField={setModifiedAssets}
            handleChange={handleAssetChange}
            storeSelectedValue={storeSelectedValue}
            setStoreSelectedValue={setStoreSelectedValue}
            storeOffice={row?.req_store}
          />

          <ModalFooter>
            <Button onClick={handleCloseModifyModal}>Cancel</Button>
            <ActionButton 
              onClick={handleConfirmModification}
              disabled={modifiedAssets.some(asset =>
                !asset.catName || !asset.assetName || !asset.quantity
              )}
            >
              Confirm Modification
            </ActionButton>
          </ModalFooter>
        </Box>
      </Modal>
    </>
  );
};

export default UserInboxForm; 